import _ from 'lodash'
import { APP_SETTINGS } from '@/common/config'
import axiosIns from '@/libs/axios'
import useJwt from '@/auth/jwt/useJwt'
import SystemHelper from '@/common/systemHelper'

export const GET_INTRODUCER_DASHBOARD = 'getIntroducerDashboard'
export const SET_INTRODUCER_DASHBOARD = 'setIntroducerDashboard'

export default {
  namespaced: true,
  state: {
    introducerDashboard: null,
  },
  getters: {
    getIntroducerDashboard: state => {
      const currentState = state.introducerDashboard

      if (currentState) {
        return currentState
      }
      return []
    },
  },
  mutations: {
    [SET_INTRODUCER_DASHBOARD](state, val) {
      state.introducerDashboard = val
    },
  },
  actions: {
    [GET_INTRODUCER_DASHBOARD](context, payload) {
      return new Promise((resolve, reject) => {
        const endpoint = 'account-introducer/dashboard/me'

        axiosIns.post(`${APP_SETTINGS.BASE_URL + APP_SETTINGS.API_VERSION_NUM}${endpoint}`, payload)
          .then(res => {
            if (res.data.response_code === 2000) {
              useJwt.setToken(res.data.token)

              context.commit(SET_INTRODUCER_DASHBOARD, res.data.data)

              SystemHelper.successHandler(res)
              resolve(res)
            } else {
              SystemHelper.errorHandler(res)
              resolve(res)
            }
          })
          .catch(err => {
            SystemHelper.handleCatch()
            reject(err)
          })
      })
    },
  },
}
